import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=6078363e&scoped=true&"
import script from "./Addresses.vue?vue&type=script&lang=ts&"
export * from "./Addresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078363e",
  null
  
)

export default component.exports